module.exports = __webpack_public_path__ + "static/res-1-lg-802d8a26423dd204ac34cae139add229.png";